enum FieldVisibility {
  Required = 1, // Visível e Obrigatório
  Visible = 2,  // Visível e Não Obrigatório
  Hidden = 3    // Não Visível Nem Obrigatório
}
export default FieldVisibility;

